<template>
  <div>
    <div>test page</div>

    <notifications group="label" position="top left" class="notice"></notifications>
    <div class="section-labelimage">
      <div class="label-radio">
        <div class="label-radio__body">
          <p>Alert type</p>
          <input
            type="radio"
            id="none"
            name="label"
            class="label-radio__body--item"
            value="CUBO_ALERT_NONE"
            v-model="alert"
          />
          <label for="none">None (keycode : Q)</label>
          <br />
          <input
            type="radio"
            id="pone"
            name="label"
            class="label-radio__body--item"
            value="CUBO_ALERT_PRONE"
            v-model="alert"
          />
          <label for="pone">Prone (keycode : W)</label>

          <br />
          <input
            type="radio"
            id="cover"
            name="label"
            class="label-radio__body--item"
            value="CUBO_ALERT_FACE_COVER"
            v-model="alert"
          />
          <label for="cover">Cover (keycode : E)</label>

          <br />
          <input
            type="radio"
            id="nobody"
            name="label"
            class="label-radio__body--item"
            value="CUBO_ALERT_NOT_IN_BED"
            v-model="alert"
          />
          <label for="nobody">No body (keycode : R)</label>
        </div>
        <div class="label-radio__box">
          <p>Box</p>
          <div class="label-type">
            <div class="label-type__item">

              <div v-if="drawingType === 'Person'" class="label-type__item--choosed bg-light-green"></div>
              <div v-else class="label-type__item--color bg-light-green"></div>
              <div class="label-type__item--type" v-on:click="()=> {this.drawingType = 'Person';}">Person</div>

              <div v-if="drawingType === 'Face'" class="label-type__item--choosed bg-purple"></div>
              <div v-else class="label-type__item--color bg-purple"></div>
              <div class="label-type__item--type" v-on:click="()=> {this.drawingType = 'Face';}">Face</div>

            </div>
            <div class="label-type__item">

              <div v-if="drawingType === 'Head'" class="label-type__item--choosed bg-red"></div>
              <div v-else class="label-type__item--color bg-red"></div>
              <div class="label-type__item--type" v-on:click="()=> {this.drawingType = 'Head';}">Head</div>

              <div v-if="drawingType === 'Hand'" class="label-type__item--choosed bg-corn-blue"></div>
              <div v-else class="label-type__item--color bg-corn-blue"></div>
              <div class="label-type__item--type" v-on:click="()=> {this.drawingType = 'Hand';}">Hand</div>

            </div>
            <div class="label-type__item">

              <div v-if="drawingType === 'Leg'" class="label-type__item--choosed bg-light-yellow"></div>
              <div v-else class="label-type__item--color bg-light-yellow"></div>
              <div class="label-type__item--type" v-on:click="()=> {this.drawingType = 'Leg';}">Leg</div>

              <div v-if="drawingType === 'Bed'" class="label-type__item--choosed bg-green"></div>
              <div v-else class="label-type__item--color bg-green"></div>
              <div class="label-type__item--type" v-on:click="()=> {this.drawingType = 'Bed';}">Bed</div>

            </div>
          </div>
        </div>
        <button class="btn btn-info" @click.prevent="hideBox()">{{PropsHideBox}} box (Esc)</button>
      </div>
      <labeledImage
      :PropsBatchType="PropsBatchType"
      :PropsBatchDate="PropsBatchDate"
      :PropsImgName="PropsImgName"
      :PropsBoxTimes="PropsBoxTimes"
      :PropsLabel="PropsLabel"
      :PropsHideBox="PropsHideBox"
      :PropsDrawingColor="PropsDrawingColor"
      :PropsLevelTwo="PropsLevelTwo"
      >
      </labeledImage>
    </div>
    <div class="label-fun">
      <button class="label-fun__btn btn btn-secondary" @click.stop.prevent="skip()">Skip</button>
      <button
        class="label-fun__btn btn btn-secondary"
        :disabled="current===1"
        @click.prevent="backward()"
      >
        <i class="fas fa-backward"></i>
      </button>
      <button
        class="label-fun__btn btn btn-secondary"
        :disabled="total===current"
        @click.prevent="forward()"
      >
        <i class="fas fa-forward"></i>
      </button>
      <button class="label-fun__btn btn btn-primary"
        @click.stop.prevent="storeAndNext()">Store &amp; Next</button>
      <p class="label-fun__btn--font">{{current}}/{{total}}</p>
    </div>
  </div>
</template>

<script>
import labeledImage from '@/components/labeledImage/labeledImage.vue';

export default {
  components: { labeledImage },
  data() {
    return {
      PropsBatchType: 'sleep_main',
      PropsBatchDate: null,
      PropsImgName: null,
      PropsBoxTimes: null,
      PropsLabel: null,
      PropsDrawingColor: null,
      PropsHideBox: 'Hide',
      PropsLandmark: null,
      PropsLevelTwo: true,
      total: 0,
      current: 0,
      alert: '', // alert type
      labeledImgName: [],
      drawingType: null,
    };
  },
  methods: {
    ApiAssignmeta() {
      const vm = this;
      const data = {
        name: vm.labeledImgName[vm.current - 1],
        type: 'sleep_main',
      };
      vm.$store.dispatch('assignmeta', data).then((response) => {
        console.log('data');
        console.log(response);
        vm.PropsBatchDate = response.batch_date;
        vm.PropsImgName = response.name;
        vm.PropsBoxTimes = response.result_bboxes;
        if (response.label_alert_type.length !== 0) {
          vm.alert = response.label_alert_type;
        } else {
          vm.alert = response.result_alert_type;
        }
      });
    },
    nextLabel() {
      const vm = this;
      if (vm.current < vm.total) {
        vm.current += 1;
        vm.ApiAssignmeta();
      } else {
        vm.$store.dispatch('Gettask', 'sleep_main').then((response) => {
          vm.PropsBatchDate = response.batch_date;
          vm.PropsImgName = response.name;
          vm.PropsBoxTimes = response.result_bboxes;
          vm.labeledImgName.push(vm.PropsImgName);
          if (response.label_alert_type.length !== 0) {
            vm.alert = response.label_alert_type;
          } else {
            vm.alert = response.result_alert_type;
          }
          vm.current += 1;
          vm.total += 1;
          console.log('data');
          console.log(response);
        });
      }
    },
    skip() {
      const vm = this;
      const next = {
        name: vm.PropsImgName,
        is_skip: true,
        type: 'sleep_main',
      };
      console.log('update:');
      console.log(next);
      vm.$store.dispatch('Updatetask', next).then(() => {
        vm.nextLabel();
      });
    },
    backward() {
      const vm = this;
      vm.current -= 1;
      vm.ApiAssignmeta();
    },
    forward() {
      const vm = this;
      vm.current += 1;
      vm.ApiAssignmeta();
    },
    storeAndNext() {
      const vm = this;
      const next = {
        name: vm.PropsImgName,
        label_alert_type: vm.alert,
        is_skip: false,
        type: 'sleep_main',
      };
      console.log('update:');
      console.log(next);
      vm.$store.dispatch('Updatetask', next).then(() => {
        vm.nextLabel();
      });
    },
    hideBox() {
      const vm = this;
      if (vm.PropsHideBox === 'Hide') {
        vm.PropsHideBox = 'Show';
      } else {
        vm.PropsHideBox = 'Hide';
      }
    },

  },
  mounted() {
    const vm = this;
    vm.nextLabel();
    // eslint-disable-next-line
    document.onkeydown = function (e) {
      const keycode = {
        KeyQ: () => {
          vm.alert = 'CUBO_ALERT_NONE';
        },
        KeyW: () => {
          vm.alert = 'CUBO_ALERT_PRONE';
        },
        KeyE: () => {
          vm.alert = 'CUBO_ALERT_FACE_COVER';
        },
        KeyR: () => {
          vm.alert = 'CUBO_ALERT_NOT_IN_BED';
        },
        Escape: () => {
          vm.hideBox();
        },
        ArrowUp: () => {
          vm.skip();
        },
        Enter: () => {
          vm.storeAndNext();
        },
        ArrowLeft: () => {
          if (vm.current !== 1) {
            vm.backward();
          }
        },
        ArrowRight: () => {
          if (vm.total !== vm.current) {
            vm.forward();
          }
        },
      };
      keycode[e.code]();
    };
  },
  watch: {
    drawingType() {
      if (this.drawingType === 'Person') {
        this.PropsDrawingColor = '#24ceb9';
      } else if (this.drawingType === 'Face') {
        this.PropsDrawingColor = 'darkorchid';
      } else if (this.drawingType === 'Head') {
        this.PropsDrawingColor = 'red';
      } else if (this.drawingType === 'Hand') {
        this.PropsDrawingColor = 'cornflowerblue';
      } else if (this.drawingType === 'Leg') {
        this.PropsDrawingColor = 'khaki';
      } else if (this.drawingType === 'Bed') {
        this.PropsDrawingColor = 'green';
      }
    },
  },

};


</script>
